import Head from "next/head";
import { useEffect } from "react";

import NotFound from "./not-found";

import AuthWrapper from "src/components/authentication";
import { TrackingEvent } from "src/common/trackingEvents";
import { useMultiAccountFeature } from "src/libraries/organisation/multi-accounts/hooks";
import { useSegment } from "src/technical-integrations/segment/useSegment";

const FourZeroFourPage: React.FC = () => {
  const { hasMultiAccountFeature, isLoading: isMultiAccountDecisionLoading } =
    useMultiAccountFeature();

  const { sendEvent } = useSegment();

  useEffect(() => {
    if (isMultiAccountDecisionLoading) return;

    sendEvent(TrackingEvent.DASHBOARD_404_PAGE_VIEWED, {
      multi_account_merchant: hasMultiAccountFeature,
    });
  }, [hasMultiAccountFeature, isMultiAccountDecisionLoading, sendEvent]);

  return (
    <AuthWrapper>
      <Head>
        <title>GoCardless - 404</title>
      </Head>
      <NotFound />
    </AuthWrapper>
  );
};

export default FourZeroFourPage;
